<template>
    <div class="row mt-5">
        <div class="col-8 offset-2 div-checkout">
            <legend>{{ translate.PlansSubTitle }}</legend>
            <div class="list-plans px-1 my-5">
                <vue-collapsible-panel-group base-color="#2d2b3b">
                    <vue-collapsible-panel v-for="(title, key) in titles" :key="key" :expanded="false">
                        <template #title>
                            {{ title }}
                        </template>
                        <template #content>
                            {{ ' ' }}
                            <component :is="listComponents[key]" @showBoleto="showPdf"
                                @showModalMessages="showModalErro"></component>
                        </template>
                    </vue-collapsible-panel>
                </vue-collapsible-panel-group>
            </div>
        </div>
    </div>
</template>
  
<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/assine'
import FormPix from 'components/Assine/FormPix.vue'
import FormPaymentCreditCard from 'components/Assine/FormPaymentCreditCard.vue'
import FormTransferItau from 'components/Assine/FormTransferItau.vue'
import FormBoleto from 'components/Assine/FormBoleto.vue'

export default defineComponent({
    name: 'CollapseBox',
    components: {
        FormPix,
        FormPaymentCreditCard,
        FormTransferItau,
        FormBoleto,
    },
    emits: ['showModalMessages', 'boleto'],
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        },
        listComponents: function () {
            if (this.locale === 'pt-br') {
                return ['FormPaymentCreditCard', 'FormTransferItau', 'FormPix', 'FormBoleto']
            } else {
                return ['FormPaymentCreditCard']
            }
        },
        titles: function () {
            if (this.locale === 'pt-br') {
                return ['Cartão de Crédito', 'Transferência Eletrônica ITAÚ', 'PIX', 'Boleto Bancário']
            } else {
                return ['Credit Card']
            }
        }
    },
    data() {
        return {}
    },
    methods: {
        showModalErro(data) {
            this.$emit('showModalMessages', data);
        },
        showPdf(url: string) {
            this.$emit('boleto', url);
        }
    }
})
</script>
  
<style lang="css" scoped>
legend {
    font-family: 'Roboto-Medium';
    line-height: 28px;
    font-size: 24px;
    color: #b40909;
    margin-bottom: 50px;
    margin-left: 10px;
}

.vcpg {
    color: #000;
    border: none !important;
}

.vcpg :deep(.vcp__header) {
    border-radius: 35px;
    background-color: #ffff !important;
    margin-top: 10px;
    padding: 26px;
    border: 1px solid var(--border-color);
}

.vcpg :deep(.vcp__body) {
    border-top: none !important;
    height: auto;
}

.vcpg :deep(.vcp__header-title) {
    font-family: 'Roboto-Bold';
    font-size: 16px;
    line-height: 19px;

}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-checkout {
        width: 100%;
        margin-left: 0px;
    }

    legend {
        font-size: 18px;
    }

}
</style>
  